import React from 'react';
import '../styles/SuggestionCard.css';
import { PlayCircleOutline } from '@material-ui/icons';

const SuggestionCard = () => {
  return (
    <div className="suggestion">
      <div className="suggestion__left">
        <img
          className="suggestion__img"
          src="https://i.ytimg.com/vi/vgr2y70Vlk0/maxresdefault.jpg"
          alt=""
        />
        <PlayCircleOutline className="suggestion__playicon" fontSize="large" />
      </div>
      <div className="suggestion__right">
        <h3>Title</h3>
        <p>Description</p>
      </div>
    </div>
  );
};

export default SuggestionCard;
